import DocumentSelection from './DocumentSelection';

export default DocumentSelection;
